import { useEffect, useState } from 'react';
import { onAuthStateChanged, User } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from './firebase';

export interface AdminUser {
  uid: string;
  email: string | null;
  roles: string[];
  isAdmin: boolean;
}

export interface AuthState {
  loading: boolean;
  user: AdminUser | null;
}

export function useAuthState(): AuthState {
  const [state, setState] = useState<AuthState>({ loading: true, user: null });

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (fbUser: User | null) => {
      if (!fbUser) {
        setState({ loading: false, user: null });
        return;
      }
      try {
        const snap = await getDoc(doc(db, 'users', fbUser.uid));
        const roles: string[] = snap.exists()
          ? (snap.data().roles as string[]) || []
          : [];
        const tokenResult = await fbUser.getIdTokenResult();
        const claimRole = tokenResult.claims.role;
        const isAdmin = roles.includes('admin') || claimRole === 'admin';
        setState({
          loading: false,
          user: {
            uid: fbUser.uid,
            email: fbUser.email,
            roles,
            isAdmin,
          },
        });
      } catch (e) {
        console.error('Failed to load admin user', e);
        setState({ loading: false, user: null });
      }
    });
    return unsub;
  }, []);

  return state;
}
